import React from 'react'
import PropTypes from 'prop-types'

import Question from './Question'
import {submissionsClosed} from "../utils";
import AddComment from "./Board/AddComment";

const Questions = ({ edges, pageInfo, board, onLoadMore, boardRefreshHandler }) => {
  if (edges.length === 0) {
    return <div>&nbsp;</div>
  }
  return (
      <div className="container">
      {edges.map(({ node: question }, index) => {
        const isLast = edges.length === index + 1
        // return <Question key={question.uuid} question={question} isLast={isLast} board={board} boardRefreshHandler={() => this.props.boardRefreshHandler()} />
        //   return <Question key={question.uuid} question={question} isLast={isLast} board={board} boardRefreshHandler={() => this.props.boardRefreshHandler()} />
          return <Question key={question.uuid} question={question} isLast={isLast} board={board} boardRefreshHandler={boardRefreshHandler} />
      })}

      {pageInfo.hasNextPage ? (
        <div className="col-lg-4 offset-lg-4 text-center">
          <button className="btn btn-primary" onClick={onLoadMore}>
            Show more
          </button>
        </div>
      ) : null}
    </div>
  )
}

Questions.propTypes = {
  edges: PropTypes.array.isRequired,
  pageInfo: PropTypes.object.isRequired,
  board: PropTypes.object.isRequired,
  onLoadMore: PropTypes.func.isRequired,
}

export default Questions



// WEBPACK FOOTER //
// ./src/components/Questions.jsx